import Impression from '~/app/components-nds/common/impression'

import React from 'react'

type BenefitBannerProps = {
  url: string
  onImpressed?: () => void
  onClick?: () => void
}

const BenefitBanner = ({ url, onImpressed, onClick }: BenefitBannerProps) => {
  return (
    <Impression onImpressed={onImpressed}>
      <div className="mx-auto w-full bg-static-white">
        <div
          role="button"
          aria-label="Benefit banner"
          onClick={onClick}
          className="h-60 w-full cursor-pointer rounded-12 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${url})` }}
        />
      </div>
    </Impression>
  )
}

export default BenefitBanner
